(function () {
  'use strict';

  function odrDistributionFactory (Common, apiFactory, Translation) {
    const factory = {};

    /* NOTE:
        standard = inidividuals
        exclusive = companies
    */

    const isExclusive = {
      0: 'INDIVIDUALS',
      1: 'COMPANIES'
    };

    function destroyModels () {
      console.log('destroy called');
      // here you will destroy odr models upon leaving the page
      factory.materialModel = null;
      factory.centerModel = null;
      factory.terminalModel = null;
    }

    function setDimensionModels () {
      // here you will set models, from common
      factory.materialModel = Common.get('productDelivery.odrDetails.materialDetails', {});
    }

    function setCenterModel () {
      // here you will set models, from common
      factory.centerModel = Common.get('productDelivery.odrDetails.center', getODRCenters()[1].unitType);
      if (!factory.centerModel) {
      //   // always set to exclusive dimension limit
        Common.set('productDelivery.odrDetails.center', factory.centerModel);
      }
    }

    function setTerminalModel () {
      // here you will set models, from common
      factory.terminalModel = Common.get('productDelivery.odrDetails.terminal', null);
    }

    function setCalendarModels () {
      factory.calendarModels = {
        exclusive: true
      };
    }

    // modelKey can be: centerModel, terminalModel, materialModel
    function getFormModels (modelKey) {
      // here you will return the specified model
      return factory[modelKey];
    }

    function getCalendarModels () {
      return factory.calendarModels;
    }

    function validateWidthLength (val, key, limit) {
      const services = {
        width: 'exclusive',
        length: 'exclusive',
        thickness: 'exclusive',
        weight: 'exclusive'
      };
      let conditions;

      if (key === 'width' || key === 'length') {
        conditions = {
          min: val >= factory.dimensionLimits[services[key]][key].min,
          max: val <= factory.dimensionLimits[services[key]][key].max
        };
      } else {
        conditions = {
          min: val > 0,
          max: val <= factory.dimensionLimits[services[key]][key].max
        };
      }

      // if the value is not in range with the limits, set it with default limits
      if (!conditions[limit]) {
        val = factory.dimensionLimits[services[key]][key][limit];
      }
      return val;
    }

    function checkMaterialDetails () {
      ['width', 'length', 'thickness', 'weight'].forEach((key) => {
        if (angular.isDefined(factory.materialModel[key])) {
          factory.materialModel[key] = validateWidthLength(factory.materialModel[key], key, 'min'); // validate and replace value
          factory.materialModel[key] = validateWidthLength(factory.materialModel[key], key, 'max'); // validate and replace value
        }
      });
    }

    function saveModels (selectedDate, terminal, center) {
      // check formModels
      checkMaterialDetails();
      const odrDetails = {
        materialDetails: factory.materialModel,
        terminal: factory.terminalModel,
        center: factory.centerModel
      };

      Common.set('materialDetails', factory.materialModel);
      Common.set('productDelivery.odrDetails', odrDetails);

      if (selectedDate) {
        Common.set('productDelivery.deliveryDate', selectedDate);
      }

      if (terminal) {
        factory.terminalModel = terminal;
        Common.set('productDelivery.odrDetails.terminal', terminal);
      }

      if (center) {
        factory.centerModel = center;
        Common.set('productDelivery.odrDetails.center', center);
      }
    }

    function checkMaterialDimensions (key, limit) {
      return ((factory.materialModel || {})[key] || 0) >= (limit || 0);
    }

    function checkMaterialWeightThickness (key, limit) {
      return ((factory.materialModel || {})[key] || 0) <= (limit || 0);
    }

    function checkODRProduct () {

      const formKeys = ['width', 'length', 'thickness', 'weight'];
      const odrCenterValid = !!factory.centerModel;
      const terminalValid = !!factory.terminalModel; // uncomment this when this is ready
      let formValid = true;
      let index = 0;

      while (formValid && index < formKeys.length) {
        const val = ((factory.materialModel|| {})[formKeys[index]]);
        formValid = val > 0;
        index++;
      }

      return odrCenterValid && terminalValid && formValid;
    }

    function checkStandardValidity () {
      const limits = (factory.dimensionLimits || {}).standard || {};

      return Common.get('recipients.targetType', 'INDIVIDUALS') !== 'COMPANIES'
        && checkMaterialDimensions('width', (limits.width || {}).min) && checkMaterialDimensions('length', (limits.length || {}).min)
        && checkMaterialWeightThickness('thickness', (limits.thickness || {}).max) && checkMaterialWeightThickness('weight', (limits.weight || {}).max);
    }

    // this is for both stf odr and odr only
    function isProductValid () {
      const service = Common.get('serviceType', 'admail-letter');
      let valid = false;

      if (service === 'admail-odr' && angular.isDefined(factory.materialModel)) {
        valid = checkODRProduct();
      } else {
        // when it is other rfix service
        valid = true;
      }

      return valid;
    }

    function getODRCenters () {
      // TODO: call api here
      // save result in factory

      // temporary data
      return [/* {
        unitType: 'odr',
        time: '12:00',
        daysSubmissionDeadline: 3,
        center: 'ODR_ODR_TERMINAL'
      },  */{
          unitType: 'letter',
          time: '18:00',
          daysSubmissionDeadline: 6,
          center: 'ODR_LETTER_TERMINAL'
        }, {
          unitType: 'company',
          time: '18:00',
          daysSubmissionDeadline: 6,
          center: 'ODR_BUSINESS_TERMINAL'
        }];
    }

    function getODRServiceDeadline () {
      //Separated from ODR centers
      return [{
        unitType: 'ODR Exclusive',
        time: '18:00',
        daysSubmissionDeadline: 6
      }];
    }

    function getDeliveryOption (product, selectedDate, initDelivery, deliveryOverride) {
      const date = new Date(selectedDate); // basing on selected date
      let exclusiveKey = Number(date.getDay() === 1 || date.getDay() === 3);
      if (deliveryOverride) {
        exclusiveKey = Number(deliveryOverride.service === 'exclusive');
      }
      return product.pricingInfo.deliveryOptions.filter((item) => {
        return item.addressType === 'ODR'
          && item.targetType === (initDelivery
            || isExclusive[exclusiveKey]);
      })[0];
    }

    function getAddons (addOns) {
      // things to look: block booking
      // recipients filter
      const blockBooking = Common.get('recipients').blockAddressCount;
      const filter = Common.get('recipients').odrFilters[Common.get('recipients.targetType')].formOfHousing.toLowerCase();

      const filteredAddons = addOns.filter((item) => {
        if (item.block && !item.formOfHousing) {
          return blockBooking;
        } else if (item.formOfHousing && !item.block) {
          return item.formOfHousing.indexOf(filter) > -1;
        }
      });
      return filteredAddons;
    }

    function restructureProduct (product, selectedDate, initDelivery, deliveryOverride) {
      product.pricingInfo.deliveryOptions = getDeliveryOption(product, selectedDate, initDelivery, deliveryOverride);

      if (selectedDate) {
        product.deliveryDate = selectedDate;
      }

      if (Common.get('serviceType', 'admail-letter') === 'admail-odr') {
        product.pricingInfo.deliveryOptions.ODRAddons = getAddons(product.pricingInfo.deliveryOptions.ODRAddons);
      }
      return product;
    }

    function changeDeliveryOption (date, deliveryOverride) {
      const product = angular.copy(factory.untouchedProduct);
      product.pricingInfo.deliveryOptions = getDeliveryOption(product, date, false, deliveryOverride);
      factory.ODRService = product.pricingInfo.deliveryOptions.ODRService;

      product.deliveryDate = date;
      product.odrDetails = {
        materialDetails: factory.materialModel,
        terminal: factory.terminalModel,
        center: factory.centerModel
      };

      if (Common.get('serviceType', 'admail-letter') === 'admail-odr') {
        product.pricingInfo.deliveryOptions.ODRAddons = getAddons(product.pricingInfo.deliveryOptions.ODRAddons);
      }

      return product;
    }

    function getSelectedService (de) {
      return factory.ODRService;
    }

    function getDimensionLimit (service, deliveryOptions) {
      const option = deliveryOptions.filter(item => item.ODRService === service)[0];

      return {
        width: option.width,
        length: option.length,
        thickness: option.thickness,
        weight: option.weight,
      };
    }

    function setDimensionLimit (deliveryOptions) {
      factory.dimensionLimits = {
        exclusive: getDimensionLimit('exclusive', deliveryOptions)
      };
    }

    function fetchTerminals () {
      return apiFactory.fetchTerminals.post().$promise;
    }

    function filterTerminals () {
      const selectedCenter = Common.get('productDelivery.odrDetails.center') || factory.centerModel;
      return factory.terminals.filter(item => item.unitType === selectedCenter);
    }

    function getSelectedCenter () {
      const selectedCenter = Common.get('productDelivery.odrDetails.center');
      const center = getODRCenters().filter(item => item.unitType === selectedCenter);

      if (center.length) {
        return Translation.translate(center[0].center).value;
      }
    }

    function getSelectedCenterTime () {
      const selectedCenter = Common.get('productDelivery.odrDetails.center');
      if (selectedCenter) {
        const filteredCenter = getODRCenters()
         .filter(item => item.unitType === selectedCenter);

        if (filteredCenter.length) {
          return filteredCenter[0].time;
        }
      }
      else {
        let time;
        const unitType = Common.get('productDelivery.odrDetails.terminal.unitType');
        if (unitType === 'letter' || unitType === 'company') {
          time = '18:00';
        } else if (unitType === 'odr') {
          time = '12:00';
        }
        return time;
      }
    }

    function getSelectedTerminal () {
      return Common.get('productDelivery.odrDetails.terminal');
    }

    function getCurrentUnitType () {
      if (!factory.centerModel) {
        return;
      }
      return factory.centerModel;
    }

    function getDeliveryDays (unitType) {
      //Use when submission deadline in ODR centers affects submission date
      return (getODRCenters().filter(item => item.unitType === unitType)[0] || {}).daysSubmissionDeadline || 0;
    }

    function getDeliveryDaysByService (unitType) {
      //Use when submission deadline in ODR service affects submission date
      return (getODRServiceDeadline().filter(item => item.unitType === unitType)[0] || {}).daysSubmissionDeadline || 0;
    }

    function filterTerminalsViaSearch (searchText) {
      const text = searchText.toLowerCase();
      const selectedCenter = Common.get('productDelivery.odrDetails.center') || factory.centerModel;

      return factory.terminals.filter((item) => {
        const wholeTerminal = (item.name + ',' + item.address + ' ' + item.postalCode).toLocaleLowerCase();

        return wholeTerminal.indexOf(text) > -1 && item.unitType === selectedCenter;
      });
    }

    function getExceptionDates () {
      return apiFactory.getExceptionDates.post().$promise;
    }

    function getDisabledDays () {
      return apiFactory.getDisabledDays.get().$promise;
    }


    factory.destroyModels = destroyModels;
    factory.setDimensionModels = setDimensionModels;
    factory.setCenterModel = setCenterModel;
    factory.setTerminalModel = setTerminalModel;
    factory.getFormModels = getFormModels;
    factory.saveModels = saveModels;
    factory.checkStandardValidity = checkStandardValidity;
    factory.isProductValid = isProductValid;
    factory.getODRCenters = getODRCenters;
    factory.validateWidthLength = validateWidthLength;
    factory.restructureProduct = restructureProduct;
    factory.changeDeliveryOption = changeDeliveryOption;
    factory.getSelectedService = getSelectedService;
    factory.getCalendarModels = getCalendarModels;
    factory.setDimensionLimit = setDimensionLimit;
    factory.setCalendarModels = setCalendarModels;
    factory.fetchTerminals = fetchTerminals;
    factory.filterTerminals = filterTerminals;
    factory.getSelectedCenterTime = getSelectedCenterTime;
    factory.getSelectedCenter = getSelectedCenter;
    factory.getSelectedTerminal = getSelectedTerminal;
    factory.getCurrentUnitType = getCurrentUnitType;
    factory.getDeliveryDays = getDeliveryDays;
    factory.getDeliveryDaysByService = getDeliveryDaysByService;
    factory.filterTerminalsViaSearch = filterTerminalsViaSearch;
    factory.getExceptionDates = getExceptionDates;
    factory.getDisabledDays = getDisabledDays;

    return factory;
  }

  angular.module('web2print.whereTo')
    .factory('odrDistributionFactory', odrDistributionFactory);
})();
